import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';

const idChange: GridDetailsPanelColumnDef<SymbolEventColumn>[] = [
    {
        controls: [
            { type: 'field', field: 'oldCusip' },
            { type: 'field', field: 'oldIsin' },
            { type: 'field', field: 'oldSedol' },
            { type: 'field', field: 'exDate' },
        ],
    },
    {
        controls: [
            { type: 'field', field: 'newCusip' },
            { type: 'field', field: 'newIsin' },
            { type: 'field', field: 'newSedol' },
        ],
    },
];

export default idChange;
